

import { Component, Vue, Watch, Prop } from "vue-property-decorator"

// @ts-ignore
import { Field, Recipient, RecipientType, Template, Team } from "@/types"
import { BFormGroup, BListGroup } from "bootstrap-vue"
import RecipientList from "@/components/Config/Rules/RecipientList.vue"
import Guid from "@/scripts/guid"
import { IntegrationSettings } from "@/types/integration"

@Component({
	components: {
		"recipient-list": RecipientList
	}
})
export default class NotifyOnFailure extends Vue {
	@Prop({ default: () => null })
	value!: IntegrationSettings

	@Prop({ default: () => [] })
	teams!: Team[]

	public recipients: Recipient[] | null = []

	get recipientValues () {
		if (this.value && this.value.notifyOnFailure) {
			return this.value.notifyOnFailure.map(id => {
				var recipient: Recipient = {
					key: Guid.newGuid(),
					id: id && id.startsWith("team:") ? (id.length > 5 ? id.substring(5) : undefined) : id,
					type: id && id.startsWith("team:") ? RecipientType.Team : RecipientType.User
				}
				return recipient
			})
		}
		return []
	}

	get notifyByEmail () {
		if (this.value) {
			return this.value.notifyByEmail
		}
		return false
	}

	recipientsChanged (recipients: Recipient[]) {
		var uIds = recipients.map(r => {
			return r.type === RecipientType.Team ? "team:" + (r.id ? r.id : "") : r.id
		})
		Vue.set(this.value, "notifyOnFailure", uIds)
		this.$emit("input", this.value)
	}

	notifyByEmailChanged (allowNotifyByEmail: Boolean) {
		Vue.set(this.value, "notifyByEmail", allowNotifyByEmail)
		this.$emit("input", this.value)
	}
}
